exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divisor[data-v-8938781e]{width:5px;border-radius:5px;background-color:var(--gray-400)}.content[data-v-8938781e]{line-height:normal}", ""]);

// exports
